import { callYaMetrika } from '@/utils/call-ya-metrika';
import styles from './complain-btn.module.scss';
import { OutlinedWarningIcon } from '@/assets/icons';
import { useState } from 'react';
import { useComplainProfileById } from '@/hooks/use-complain-profile-by-id';
import { ModalComplain } from '../modal-complain';

interface Props {
    profileId: number | string;
    onClick?: () => void;
}

export const ComplainBtn: React.FC<Props> = ({ profileId, onClick }) => {
    
    const [isShowComplainModal, setShowComplainModal] =
        useState<boolean>(false);
    
    const {
        mutateAsync: complainProfileById,
        isPending: isLoadingComplain
    } = useComplainProfileById();

    const handleComplainProfile = async (reason: string) => {
        try {
            await complainProfileById({ profileId, reason });
            setShowComplainModal(false);
        } catch (error) {
            console.error(error);
        }
    };
    
    return (
        <>
            <button
                className={styles.btn}
                onClick={
                    () => {
                        onClick?.()
                        setShowComplainModal(true)
                    }
                }>
                <OutlinedWarningIcon
                    width={24}
                    height={24} />
                <span>Пожаловаться</span>
            </button>
            <ModalComplain
                isOpen={isShowComplainModal}
                isLoading={isLoadingComplain}
                onClose={() => setShowComplainModal(false)}
                onSubmit={handleComplainProfile} />
        </>
    )
}
